import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import { ProfileState } from './profiles.reducer'
import * as ProfilesSelectors from './profiles.selectors'

@Injectable({
  providedIn: 'root',
})
export class ProfilesFacade implements GbBaseFacade {
  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */
  loaded$ = this.store.select(ProfilesSelectors.getProfilesLoaded)
  allProfiles$ = this.store.select(ProfilesSelectors.getAllProfiles)
  profilesCount$ = this.store.select(ProfilesSelectors.getProfilesCount)

  constructor(private store: Store<ProfileState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
